var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tile-option w-36 md:w-40 inline-flex flex-col mx-3",
      attrs: { role: "button" }
    },
    [
      _c(
        "div",
        {
          staticClass: "relative",
          class: _vm.isActive
            ? "border-4 border-velux-red"
            : "border-2 border-velux-grey-300"
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "absolute -left-1 -top-1 -bottom-1 -right-1 transition-all border-velux-red border-4 opacity-0 tile-option-border"
          }),
          _vm._v(" "),
          _vm._m(0)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-2 md:text-xl text-center" },
        [_vm._t("text-below")],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "absolute transition-opacity top-2.5 right-2.5 text-2xl leading-none text-velux-red opacity-0 tile-option-icon"
      },
      [
        _c("div", [
          _c("div", {
            staticClass:
              "absolute rounded-full top-1/2 left-1/2 w-9 h-9 transform -translate-x-1/2 -translate-y-1/2 bg-velux-white"
          }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-check-circle text-4xl relative z-10" })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }